import { Component, ViewChild } from '@angular/core';
import { ModalController, LoadingController } from 'ionic-angular';
import { PatronProvider } from '../../providers/patron/patron';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { CoPatronDetailsPage } from '../../pages/co-patron-details/co-patron-details';
import { AppState } from '../../config/state';
import { LoginProvider } from '../../providers/login/login';

/**
 * Generated class for the CoPatronLookupComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-patron-lookup',
  templateUrl: 'co-patron-lookup.html',
  inputs: ['focusHerePlease']
})
export class CoPatronLookupComponent {
  searchText: string;
  patronInfo: any;
  @ViewChild('focusHerePlease') focusHerePlease;
  constructor(private modalCtrl: ModalController, private loading: LoadingController, public patronProvider: PatronProvider, private toastAlert: ToastAlertsProvider, private state : AppState, private loginProvider: LoginProvider) {
  }

  ngAfterViewInit() {
    if (this.state.staff === true){
      setTimeout(() => {
        this.focusHerePlease.setFocus();
      }, 1000);
    }
  }

  // ngOnInit() {
  //   this.loginProvider.requireLogin((res) => {

  //   }, this)
  // }

  searchPatron() {
    if (this.searchText && this.searchText.length > 0) {
      let loader = this.loading.create({ content: "Retrieving patron info" });
      loader.present();

      this.patronProvider.getFullDetails(this.searchText).then((res) => {
        if (res && res.id != null) {
          this.patronInfo = res;
          this.patronProvider.getRegisteredEvents(res.barcode).then(events =>{
            // console.log(res);
            if (events){
              this.patronInfo.events = events;
              // console.log(events, res);
              let modal = this.modalCtrl.create(CoPatronDetailsPage, { patron: this.patronInfo }, {cssClass: 'custom-medium-wide-modal'});
              modal.present();
              loader.dismiss().catch(err=>{});
            } else {
              this.patronInfo.events = [];
              // console.log(events, res);
              let modal = this.modalCtrl.create(CoPatronDetailsPage, { patron: this.patronInfo }, {cssClass: 'custom-medium-wide-modal'});
              modal.present();
              loader.dismiss().catch(err=>{});
              // this.toastAlert.triggerToast('An error occurred, please try again', '');
              // loader.dismiss();
            };
          });
        } else {
          this.toastAlert.triggerToast('An error occurred, please try again', 'Patron Not Found');
          // this.createLibraryCardScannerPopover();
          loader.dismiss().catch(err=>{});
        };
      }).catch((err) => {
        console.log('failed to login');
        loader.dismiss().catch(err=>{});
        this.toastAlert.triggerToast('Incorrect Information', '');
      });
    } else {
      this.toastAlert.triggerToast('Please enter information', '');
    }
  }

  scanForInfo() {
    let lintWindow: any = window;
    if(lintWindow.cordova && lintWindow.cordova.plugins) {
      lintWindow.cordova.plugins.CoScanner.scan({
        color: "#ff00ff",
        message: "Please scan a patron barcode",
        isISBN: false
      }, (data) => {
        if (data.success == true) {
          this.searchText = data.result;
          this.searchPatron();
        }
      }, (error) => {
        if (error.error != 'USER_CANCELLED') {
          this.toastAlert.triggerToast('Incorrect Information', '');
        }
      });
    }

  }

  patronInfoGrab(event){
    // console.log(event)
    this.searchText = event.info;
    this.searchPatron();
  }

}



// WEBPACK FOOTER //
// ./src/components/co-patron-lookup/co-patron-lookup.ts